var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSaveDiskIcon = function SvgSaveDiskIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6F1F2",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    d: "M4 3.75h13.2l3.05 3.05v13.45H3.75V4A.25.25 0 0 1 4 3.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6F1F2",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    d: "M7 4v5.5h9V4M7 20v-6.5h10V20m0-16v3"
  })));
};
export { SvgSaveDiskIcon as ReactComponent };
export default __webpack_public_path__ + "98d7698ca55c1e899e14e8e32df8da10.svg";